module.exports = __webpack_public_path__ + "media/bootstrap-icons/tv-b0de49d0.svg";